!((document, Drupal, $, once) => {
  'use strict';

  /**
   * Toggle nav small container.
   */
  Drupal.behaviors.navSmall = {
    attach: context => {

      $(once('navSmall', '.js-nav-small-toggle-content', context))
        .each(function() {
          const $navSmall = $(this);
          const $navToggle = $('.js-nav-small-toggle-control');
          $navToggle.click(() => {
            $('body').toggleClass('js-nav-small-is-open');
            $navToggle.toggleClass('is-active');
            $navSmall.toggleClass('is-open');

            /* navSmallPadBody();  excluded as call is erroring */
          });


        });
    },
  };

  /**
   * Add accordions to menu items with sub menus.
   */
  Drupal.behaviors.navSmallItems = {
    attach: context => {
      $('.js-nav-small-items', context);
      $(once('navSmallItems', '.js-nav-small-items', context))
        .each(function() {
          const $accordionWrapper = $(this);
          $(this)
            .find('.js-nav-small-accordion')
            .each(function() {
              const $accordion = $(this);
              const $control = $(this).find('.js-nav-small-accordion-control');
              $control.click(() => {
                // Collapse all other accordions except this one.
                $accordionWrapper
                  .find('.js-nav-small-accordion')
                  .not(this)
                  .each(function() {
                    $(this)
                      .find('.js-nav-small-accordion-content')
                      .removeClass('is-open');
                    $(this)
                      .find('.js-nav-small-accordion-control')
                      .removeClass('is-active');
                  });

                // Expand this one.
                $accordion
                  .find('.js-nav-small-accordion-content')
                  .toggleClass('is-open');
                $accordion
                  .find('.js-nav-small-accordion-control')
                  .toggleClass('is-active');
              });
            });
        });
    },
  };
})(document, Drupal, jQuery, once);
